/*
 *
 * Login actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import loginConstants from './constants';

export interface LoginCredentials {
  loginId: string;
  password: string;
}

export interface User {
  memberCode: string;
  memberId: number;
  language: string;
  token: string;
}

export const loginRequest = createAction(
  loginConstants.LOGIN_REQUEST,
  function prepare(credentials: LoginCredentials) {
    return { payload: credentials };
  },
);

export const loginSuccess = createAction(
  loginConstants.LOGIN_SUCCESS,
  function prepare(user: User) {
    return { payload: user };
  },
);

export const loginFailure = createAction(
  loginConstants.LOGIN_FAILURE,
  function prepare(error: string) {
    return { payload: error };
  },
);

export const logout = createAction(loginConstants.LOGOUT, function prepare() {
  return { payload: {} };
});

export const checkAuth = createAction(
  loginConstants.CHECK_AUTH,
  function prepare() {
    return { payload: {} };
  },
);

// Refresh token actions
export const refreshTokenRequest = createAction(
  loginConstants.REFRESH_TOKEN_REQUEST,
  function prepare() {
    return { payload: {} };
  },
);

export const refreshTokenSuccess = createAction(
  loginConstants.REFRESH_TOKEN_SUCCESS,
  function prepare(accessToken: string) {
    return { payload: accessToken };
  },
);

export const refreshTokenFailure = createAction(
  loginConstants.REFRESH_TOKEN_FAILURE,
  function prepare(error: string) {
    return { payload: error };
  },
);

export const updateAccessToken = createAction(
  loginConstants.UPDATE_ACCESS_TOKEN,
  function prepare(accessToken: string) {
    return { payload: accessToken };
  },
);

export const defaultAction = createAction(
  loginConstants.DEFAULT_ACTION,
  function prepare() {
    return { payload: {} };
  },
);

export const defaultActionSuccess = createAction(
  loginConstants.DEFAULT_ACTION_SUCCESS,
  function prepare(data: any) {
    return { payload: { data } };
  },
);

export const defaultActionError = createAction(
  loginConstants.DEFAULT_ACTION_ERROR,
  function prepare(error: any) {
    return { payload: { error } };
  },
);
